export enum ETimecardPageApproveOptions {
    ApproveStatusForPage,
    ApproveStatusForAll
}